import { PureComponent } from "react";

import { TriggerButton } from "widgets";

import { PopoverController } from "../core/overlays/components/OverlayControllers.js";
import AddVocabularyTermForm from "./AddVocabularyTermForm.js";

interface IVocabularyTermManagerControlsProps {
  itemsSelected: boolean;
  doesControlledValueExist: (term: string) => boolean;
  parentComponent: any;
  maxTermLength: number;
  deleteDisabled?: boolean;

  onAddTerm: (term: string) => void;
  handleRemoveSelection: () => void;
}

class VocabularyTermManagerControls extends PureComponent<IVocabularyTermManagerControlsProps> {
  constructor(props: IVocabularyTermManagerControlsProps) {
    super(props);
  }

  render() {
    return (
      <div style={{ display: "flex", alignItems: "center", height: 60, float: "right" }}>
        <PopoverController
          withForm
          actionWidget={(controllerProps) => (
            <TriggerButton
              {...controllerProps}
              icon={"add"}
              tooltip={"Add a new vocabulary term to the list"}
              label={"Add"}
              showLabel
            />
          )}
        >
          {(controllerProps) => (
            <AddVocabularyTermForm
              {...controllerProps}
              onAddTerm={this.props.onAddTerm}
              doesControlledValueExist={this.props.doesControlledValueExist}
              maxTermLength={this.props.maxTermLength}
            />
          )}
        </PopoverController>

        <TriggerButton
          key={"remove-attribute"}
          icon={"remove"}
          tooltip={"Remove the selection from the list"}
          isDisabled={this.props.deleteDisabled ? "You can't delete existing vocabulary terms" : null}
          onPress={this.props.handleRemoveSelection}
          label={"Remove"}
          showLabel
        />
      </div>
    );
  }
}

export default VocabularyTermManagerControls;
